import { forwardRef, type Ref, type SVGProps } from "react";

function SvgDiamondColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 89 89" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M34.5322 4.77441C39.968 -0.724385 48.782 -0.724386 54.2178 4.77441L55.2363 5.80371C57.7155 8.3116 61.0768 9.71966 64.5811 9.71973H64.8408C72.5314 9.71978 78.7586 16.0259 78.7588 23.7959V24.0586C78.7588 27.6074 80.1526 31.0104 82.6318 33.5186L83.6494 34.5479C89.083 40.0446 89.083 48.9554 83.6494 54.4521L82.6318 55.4814C80.1526 57.9896 78.7588 61.3926 78.7588 64.9414V65.2041C78.7586 72.9741 72.5314 79.2802 64.8408 79.2803H64.5811C61.0768 79.2803 57.7155 80.6884 55.2363 83.1963L54.2178 84.2256C48.782 89.7244 39.968 89.7244 34.5322 84.2256L33.5137 83.1963C31.0345 80.6884 27.6732 79.2803 24.1689 79.2803H23.9092C16.2186 79.2802 9.99143 72.9741 9.99121 65.2041V64.9414C9.99121 61.3926 8.59744 57.9897 6.11816 55.4814L5.10059 54.4521C-0.333 48.9554 -0.333 40.0446 5.10059 34.5479L6.11816 33.5186C8.59744 31.0103 9.99121 27.6074 9.99121 24.0586V23.7959C9.99142 16.0259 16.2186 9.71978 23.9092 9.71973H24.1689C27.6732 9.71966 31.0345 8.3116 33.5137 5.80371L34.5322 4.77441Z"
        fill="url(#diamond_colored_svg__a)"
        stroke="#FFB7B7"
        strokeWidth="0.7"
      />
      <path
        d="M23.8059 35.0913L42.3276 24.9037C42.6476 24.7277 43.0068 24.6354 43.372 24.6354C43.7371 24.6354 44.0963 24.7277 44.4163 24.9037L62.938 35.0913C63.2035 35.2373 63.4355 35.4373 63.6189 35.6784C63.8023 35.9196 63.933 36.1965 64.0028 36.4914C64.0725 36.7862 64.0796 37.0924 64.0237 37.3901C63.9677 37.6879 63.8499 37.9706 63.678 38.22L45.1551 65.0758C44.9559 65.3645 44.6895 65.6005 44.3789 65.7636C44.0683 65.9266 43.7227 66.0117 43.372 66.0117C43.0212 66.0117 42.6756 65.9266 42.365 65.7636C42.0544 65.6005 41.788 65.3645 41.5888 65.0758L23.066 38.2211C22.894 37.9717 22.7762 37.689 22.7202 37.3912C22.6643 37.0935 22.6714 36.7873 22.7411 36.4924C22.8109 36.1976 22.9417 35.9207 23.1251 35.6795C23.3084 35.4384 23.5404 35.2384 23.8059 35.0924V35.0913Z"
        fill="url(#diamond_colored_svg__b)"
      />
      <defs>
        <linearGradient
          id="diamond_colored_svg__a"
          x1="25.025"
          y1="1"
          x2="44.8053"
          y2="87.9021"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#F7D0D0" />
        </linearGradient>
        <linearGradient
          id="diamond_colored_svg__b"
          x1="29.5793"
          y1="29.8074"
          x2="43.371"
          y2="66.0121"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82090F" />
          <stop offset="1" stopColor="#B0676A" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgDiamondColored);
export default ForwardRef;
